import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Evaluation } from './evaluation.model';

@Injectable()
export class EvaluationService {
    constructor(private http: HttpClient) {}

    findBySessionId(sessionId): Observable<Evaluation[]> {
        return this.http.get<Evaluation[]>(
            '/api/sessions/' + sessionId + '/evaluations'
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/evaluation/evaluation.service.ts